export default __webpack_public_path__ + "static/media/hayat4.81353c5e.mp4";